<template>
  <div>
    <div class="list-header">{{ collectionTitle }} ({{ resultCount }} Videos)</div>
    <div class="form-entry">
          <b-button-toolbar aria-label="Toolbar with button groups and dropdown menu">
            <b-button-group size="sm" class="filter-button-box mx-1">
              <b-button class="filter-button"
                v-bind:class="{ 'filter-botton-selected': isFilterNewEnabled }"
                @click='onFilterChange("onlyNew")'
              >New</b-button>
              <b-button class="filter-button"
                v-bind:class="{ 'filter-botton-selected': isFilterUpdatesEnabled }"
                @click='onFilterChange("onlyUpdates")'
              >Upd.</b-button>
            </b-button-group>
            <input
              class="form-control"
              type="text"
              v-model="form.searchTerm"
              placeholder="filter..."
              v-on:input="onFilterChange()"
            >
            <b-button-group size="sm" class="filter-button-box mx-1">
              <b-button class="filter-button"
                v-bind:class="{ 'filter-botton-selected': isFilterMoviesEnabled }"
                @click='onFilterChange("onlyMovies")'
              >M</b-button>
              <b-button class="filter-button"
                v-bind:class="{ 'filter-botton-selected': isFilterSeriesEnabled }"
                @click='onFilterChange("onlySeries")'
              >S</b-button>
            </b-button-group>
          </b-button-toolbar>
    </div>

    <div class="label-filter">
      Label:
      <a-radio-group defaultValue="all" size="small" @change="onLabelFilterChanged">
        <a-radio-button value="all">alles</a-radio-button>
        <a-radio-button value="new">neu</a-radio-button>
        <a-radio-button value="ending">endet</a-radio-button>
        <a-radio-button value="featured">featured</a-radio-button>
        <a-radio-button value="pop">pop</a-radio-button>
      </a-radio-group>
    </div>

    <div class="scroll-box">
      <div class="video-list">
        <router-view></router-view>
        <v-paginator :resource_url="resource_url" @update="updateResource"></v-paginator>
        <div v-for="(video, index) in results" :key="index">
          <VideoEntry v-bind:video=video v-bind:globalImageUrlCache=globalImageUrlCache v-bind:selectedVideo=selectedVideo v-on:on-selected-video="onSelectedVideo">
          </VideoEntry>
        </div>
        <v-paginator :resource_url="resource_url" @update="updateResource"></v-paginator>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VideoEntry from './VideoEntry.vue'
import Details from './Details.vue'
import VuePaginator from 'vuejs-paginator'
// import { DatePicker, List, Button, Card, Row, Col, Radio, Input } from 'ant-design-vue'

export default {
  name: 'VideoList',
  components: {
    VideoEntry,
    VPaginator: VuePaginator,
    Details
  },
  props: [
    'collectionName',
    'collectionTitle',
    'externalSearchTerm',
    'globalImageUrlCache'
  ],
  data () {
    return {
      results: [],
      resultCount: '...',
      activeCollectionName: '',
      resource_url: '',
      isLoadingNewCollection: true,
      isFilterSeriesEnabled: false,
      isFilterMoviesEnabled: false,
      form: {
        searchTerm: ''
      },
      selectedVideo: '',
      isFilterUpdatesEnabled: false,
      isFilterNewEnabled: false
    }
  },
  watch: {
    collectionName: function (val) {
      // when the hash prop changes, this function will be fired.
      this.isLoadingNewCollection = true
      this.activeCollectionName = val
      this.resource_url = 'http://vod-qa-dashboard.mixd.tv:3000/movies/' + val + '/all/all/10/1/'
      this.getStats()
    },
    externalSearchTerm: function (val) {
      console.log('External search term was ingested')
      this.form.searchTerm = val
      this.onFilterChange()
    }
  },
  methods: {
    updateResource (data) {
      this.getStats()
      this.results = data
      if (this.results && this.isLoadingNewCollection) {
        this.isLoadingNewCollection = false
        this.selectedVideo = this.results[0]['_id']
        this.$emit('on-selected-video', this.results[0]) // Auto select first video on change
      }
    },
    onSelectedVideo: function (selectedVideo) {
      this.selectedVideo = selectedVideo['_id']
      this.$emit('on-selected-video', selectedVideo) // bubble through to layout - to send to details view.
    },
    onLabelFilterChanged: function (event) {
      this.selectedLabelFilter = event.target.value
      this.onFilterChange(null)
    },
    onFilterChange: function (filterValue) {
      let updateType = 'all'
      let videoType = 'all'

      console.log('TYPING... ' + this.form.searchTerm)

      if (this.isFilterMoviesEnabled) {
        videoType = 'movies'
      }
      if (this.isFilterSeriesEnabled) {
        videoType = 'series'
      }
      if (this.isFilterUpdatesEnabled) {
        updateType = 'updates'
      }
      if (this.isFilterNewEnabled) {
        updateType = 'new'
      }

      if (filterValue === 'onlyUpdates') {
        if (this.isFilterUpdatesEnabled) {
          // unset
          updateType = 'all'
          this.isFilterUpdatesEnabled = false
          this.isFilterNewEnabled = false
        } else {
          updateType = 'updates'
          this.isFilterUpdatesEnabled = true
          this.isFilterNewEnabled = false
        }
      }

      if (filterValue === 'onlyNew') {
        if (this.isFilterNewEnabled) {
          // unset
          updateType = 'all'
          this.isFilterUpdatesEnabled = false
          this.isFilterNewEnabled = false
        } else {
          updateType = 'new'
          this.isFilterUpdatesEnabled = false
          this.isFilterNewEnabled = true
        }
      }

      if (filterValue === 'onlyMovies') {
        if (this.isFilterMoviesEnabled) {
          // unset
          videoType = 'all'
          this.isFilterMoviesEnabled = false
          this.isFilterSeriesEnabled = false
        } else {
          videoType = 'movies'
          this.isFilterMoviesEnabled = true
          this.isFilterSeriesEnabled = false
        }
      }

      if (filterValue === 'onlySeries') {
        if (this.isFilterSeriesEnabled) {
          // unset
          videoType = 'all'
          this.isFilterMoviesEnabled = false
          this.isFilterSeriesEnabled = false
        } else {
          videoType = 'series'
          this.isFilterMoviesEnabled = false
          this.isFilterSeriesEnabled = true
        }
      }
      // this.resource_url = 'http://localhost:3000/movies/' + this.activeCollectionName + '/' +
      // this.resource_url = 'http://vod-qa-dashboard.mixd.tv:3000/movies/' + this.activeCollectionName + '/' +
      // this.resource_url = updateType + '/' + videoType + '/10/1/?search=' + this.form.searchTerm + '&labelFilter=' + this.selectedLabelFilter
      this.resource_url = `${this.$hostname}/movies/${this.activeCollectionName}/${updateType}/${videoType}/10/1/?search=${this.form.searchTerm}&labelFilter=${this.selectedLabelFilter}`
    },
    getStats () {
      if (this.collectionName && this.collectionName !== '') {
        // axios.get('http://vod-qa-dashboard.mixd.tv:3000/stats/' + this.activeCollectionName + '/')
        axios.get(`${this.$hostname}/stats/${this.activeCollectionName}/`)
          .then(response => {
            this.resultCount = response.data.msg.resultCount
          })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list-header {
  background-color: rgba(255,255,255,0.25);
  font-size: 12px;
  height: 19px;
}
.form-entry {
  display: flex;
  background-color: rgba(255,255,255,0.2);
}
.label-filter {
  justify-content: center;
  background-color: rgba(255,255,255,0.2);
  padding: 3px;
  font-size: 12px;
}
.form-control{
  width: 158px;
  height: 26px;
  font-size: 12px;
  font-weight: 700;
  margin: 2px;
}
.filter-button-box {
  height: 26px;
  margin: 2px;
}
.filter-button {
  padding-bottom: 0;
  padding-top: 0;
  font-size: 9px !important;
  font-weight: 400;
}
.filter-botton-selected {
  background-color: #070;
}
.scroll-box {
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100% - 79px);
}
.video-list {
  background-color: rgba(255,255,255,0.2);
  color: #000;
}
.v-paginator {
  font-size: 10px;
  padding: 3px;
  background-color: rgba(255,255,255,0.4);
  // background-color: rgba(0,0,0,0.4);
}

.v-paginator >>> .btn{
  font-size: 10px;
  padding: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoList.vue